// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* genral landing page style */
.landingpage {
  position: relative;
  width: 100%;
  margin-bottom: 100px;
}

.landingpage .slider {
  position: relative;
  width: 100%;
  padding-top: 57.8%;
}

/* landing page image section style */
.landingpage .slider img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain; 
  object-position: center bottom; 
}

/* Large screens (1440px and above) */
@media (min-width: 1440px) {
  .landingpage .slider {
    padding-top: 0;
    height: 93vh;
  }
  
  .landingpage .slider img {
    object-fit: cover; 
    object-position: center center; 
  }
}

@media (max-width: 768px) {
  .landingpage .slider {
    padding-top: 100%; 
  }
  
  .landingpage .slider img {
    object-position: center 25%; 
    object-fit: cover; 
  }
}

@media (max-width: 480px) and (min-height: 700px) {
  .landingpage .slider {
    padding-top: 120%; 
  }
}

/* landing page float icon box style  */
.landingpage .icons {
    position: absolute;
    z-index: 100;
    display: flex;
    bottom: -74px;
    left: 50%;
    transform: translate(-50%, 0);
    background-color: #FFFFFFCC;
    padding: 16px 48px;
    border-radius: 16px;
    gap: 40px;
}

.icons .icon {
    text-align: center;
    text-decoration: none;
    display: block;
    transition: all 0.3s ease;
}

.icons .icon:hover {
    transform: translateY(-2px);
}

.icons .icon .icon-img img {
    height: 70px;
    width: 70px;
    transition: filter 0.3s ease;
}

.icons .icon span {
    color: grey;
    font-weight: bold;
    display: block;
    margin: 10px 0;
    transition: color 0.3s ease;
}

.icons .icon .ic-desc {
    color: #406343;
    font-weight: bold;
}

/* Active state styles - Icon images turn green */
.icons .icon.active .icon-img img {
    filter: brightness(0) saturate(100%) invert(27%) sepia(30%) saturate(798%) hue-rotate(88deg) brightness(91%) contrast(85%);
}

/* Active state styles - Text turns green */
.icons .icon.active span {
    color: #406343 !important;
    font-weight: bold;
}

/* First icon (productions) is already green by default */
.icons .icon:first-child .ic-desc {
    color: #406343;
}

.icons .icon:first-child.active .ic-desc {
    color: #406343;
}

/* Hover effects */
.icons .icon:hover .icon-img img {
    filter: brightness(0) saturate(100%) invert(27%) sepia(30%) saturate(798%) hue-rotate(88deg) brightness(91%) contrast(85%);
}

.icons .icon:hover span {
    color: #406343;
}

@media (max-width: 768px) {
  .landingpage .icons {
    gap: 20px;
    padding: 8px 24px;
    bottom: -62px;
  }

  .icons .icon .icon-img img {
    height: 40px;
    width: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/website/Home/landing.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,qCAAqC;AACrC;EACE;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,uCAAuC;AACvC;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,SAAS;IACT,6BAA6B;IAC7B,2BAA2B;IAC3B,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA,iDAAiD;AACjD;IACI,0HAA0H;AAC9H;;AAEA,2CAA2C;AAC3C;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA,yDAAyD;AACzD;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,0HAA0H;AAC9H;;AAEA;IACI,cAAc;AAClB;;AAEA;EACE;IACE,SAAS;IACT,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;AACF","sourcesContent":["/* genral landing page style */\r\n.landingpage {\r\n  position: relative;\r\n  width: 100%;\r\n  margin-bottom: 100px;\r\n}\r\n\r\n.landingpage .slider {\r\n  position: relative;\r\n  width: 100%;\r\n  padding-top: 57.8%;\r\n}\r\n\r\n/* landing page image section style */\r\n.landingpage .slider img {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: contain; \r\n  object-position: center bottom; \r\n}\r\n\r\n/* Large screens (1440px and above) */\r\n@media (min-width: 1440px) {\r\n  .landingpage .slider {\r\n    padding-top: 0;\r\n    height: 93vh;\r\n  }\r\n  \r\n  .landingpage .slider img {\r\n    object-fit: cover; \r\n    object-position: center center; \r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .landingpage .slider {\r\n    padding-top: 100%; \r\n  }\r\n  \r\n  .landingpage .slider img {\r\n    object-position: center 25%; \r\n    object-fit: cover; \r\n  }\r\n}\r\n\r\n@media (max-width: 480px) and (min-height: 700px) {\r\n  .landingpage .slider {\r\n    padding-top: 120%; \r\n  }\r\n}\r\n\r\n/* landing page float icon box style  */\r\n.landingpage .icons {\r\n    position: absolute;\r\n    z-index: 100;\r\n    display: flex;\r\n    bottom: -74px;\r\n    left: 50%;\r\n    transform: translate(-50%, 0);\r\n    background-color: #FFFFFFCC;\r\n    padding: 16px 48px;\r\n    border-radius: 16px;\r\n    gap: 40px;\r\n}\r\n\r\n.icons .icon {\r\n    text-align: center;\r\n    text-decoration: none;\r\n    display: block;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.icons .icon:hover {\r\n    transform: translateY(-2px);\r\n}\r\n\r\n.icons .icon .icon-img img {\r\n    height: 70px;\r\n    width: 70px;\r\n    transition: filter 0.3s ease;\r\n}\r\n\r\n.icons .icon span {\r\n    color: grey;\r\n    font-weight: bold;\r\n    display: block;\r\n    margin: 10px 0;\r\n    transition: color 0.3s ease;\r\n}\r\n\r\n.icons .icon .ic-desc {\r\n    color: #406343;\r\n    font-weight: bold;\r\n}\r\n\r\n/* Active state styles - Icon images turn green */\r\n.icons .icon.active .icon-img img {\r\n    filter: brightness(0) saturate(100%) invert(27%) sepia(30%) saturate(798%) hue-rotate(88deg) brightness(91%) contrast(85%);\r\n}\r\n\r\n/* Active state styles - Text turns green */\r\n.icons .icon.active span {\r\n    color: #406343 !important;\r\n    font-weight: bold;\r\n}\r\n\r\n/* First icon (productions) is already green by default */\r\n.icons .icon:first-child .ic-desc {\r\n    color: #406343;\r\n}\r\n\r\n.icons .icon:first-child.active .ic-desc {\r\n    color: #406343;\r\n}\r\n\r\n/* Hover effects */\r\n.icons .icon:hover .icon-img img {\r\n    filter: brightness(0) saturate(100%) invert(27%) sepia(30%) saturate(798%) hue-rotate(88deg) brightness(91%) contrast(85%);\r\n}\r\n\r\n.icons .icon:hover span {\r\n    color: #406343;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .landingpage .icons {\r\n    gap: 20px;\r\n    padding: 8px 24px;\r\n    bottom: -62px;\r\n  }\r\n\r\n  .icons .icon .icon-img img {\r\n    height: 40px;\r\n    width: 40px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
